class Product {
  constructor() {
    this.container = document.querySelector(".m-main-product");

    if (!this.container || this.container.dataset.palletControlsInitialized === "true") return;

    this.container.dataset.palletControlsInitialized = "true";
    this.container.addEventListener("click", this.onClick.bind(this));
    this.container.addEventListener("change", this.onChange.bind(this));
  }

  onClick(event) {
    const quantityButton = event.target.closest("[data-pallet-qty-minus], [data-pallet-qty-plus]");

    if (quantityButton && this.container.contains(quantityButton)) {
      event.preventDefault();
      this.updatePalletQuantity(quantityButton);
      return;
    }

    const palletButton = event.target.closest(".m-add-to-cart-pallet");

    if (palletButton && this.container.contains(palletButton)) {
      event.preventDefault();
      this.addPalletToCart(palletButton);
    }
  }

  onChange(event) {
    if (event.target.matches("[data-pallet-qty-input]")) this.normalizeQuantity(event.target);
  }

  normalizeQuantity(input) {
    const minimum = Number.parseInt(input.min || "1", 10);
    const parsedValue = Number.parseInt(input.value, 10);
    const value = Number.isNaN(parsedValue) ? minimum : Math.max(minimum, parsedValue);

    input.value = value;
    return value;
  }

  updatePalletQuantity(button) {
    const row = button.closest(".m-pallet-row");
    const input = row?.querySelector("[data-pallet-qty-input]");

    if (!input) return;

    this.normalizeQuantity(input);

    if (button.matches("[data-pallet-qty-plus]")) {
      input.stepUp();
    } else {
      input.stepDown();
    }

    this.normalizeQuantity(input);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  addPalletToCart(button) {
    const form = button.closest("form");
    const palletQuantityInput = form?.querySelector("[data-pallet-qty-input]");
    const unitQuantityInput = form?.querySelector('input[name="quantity"]');
    const submitButton = form?.querySelector('button[type="submit"][name="add"]');
    const unitsPerPallet = Number.parseInt(button.dataset.palletQuantity, 10);

    if (!form || !palletQuantityInput || !unitQuantityInput || Number.isNaN(unitsPerPallet) || unitsPerPallet < 1) {
      return;
    }

    const pallets = this.normalizeQuantity(palletQuantityInput);
    const previousQuantity = unitQuantityInput.value;

    unitQuantityInput.value = unitsPerPallet * pallets;

    if (typeof form.requestSubmit === "function") {
      form.requestSubmit(submitButton || undefined);
    } else {
      form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }

    unitQuantityInput.value = previousQuantity;
  }
}

new Product();
